// extracted by mini-css-extract-plugin
export default {"cover":"Loading_cover__X4F2c","spinnerContainer":"Loading_spinnerContainer__TPh9C","spinner":"Loading_spinner__2kkId","spinner-pulse":"Loading_spinner-pulse__qt+QZ"};